import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getBarItemById } from 'src/redux/slices/bar';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import BarNewEditForm from '../bar-new-edit-form';
import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function BarEditView({ id }: Props) {
  const { status, item, error } = useAppSelector((state) => state.bar);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getBarItemById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load bar item details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.bar.root()}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Bar
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit Bar Item"
        links={[
          {
            name: 'Bar',
            href: paths.dashboard.bar.root(),
          },
          { name: 'Edit Bar Item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BarNewEditForm currentBarItem={item} />
    </Container>
  );
}
